module.exports = __webpack_public_path__ + "statics/img/10.a881136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/10.png
// module id = 5God
// module chunks = 1